import React from "react";
import { Router } from "react-router-dom";
import { LogoBox, LogoImage } from "./Logo.style";
import LazyLoad from "react-lazyload";

const Logo = ({ imageUrl, alt, onClick, height, width, cartType }) => {
  function onLogoClick() {
    window.location.href = cartType === 'express' ? "/express" : "/";
  }
  return (
			<LogoBox onClick={onLogoClick}>
				<LazyLoad once>
					<LogoImage
						src={imageUrl}
						alt={alt}
						height={height}
						width={width ? width : 160}
						loading="lazy"
						onError={(e) => {
							e.target.onerror = null;
							e.target.src =
								cartType === "express"
									? require("../../assets/icons/delixpress_logo2.svg")
									: require("../../assets/icons/delishop_logo2.svg");
						}}
					/>
				</LazyLoad>
			</LogoBox>
		);
};

export default Logo;
